const APP_ROOT = '/';

export const ROUTES = {
    HOME: `${APP_ROOT}`,
    LOGIN: `${APP_ROOT}login`,
    SIGN_UP: `${APP_ROOT}signup`,
    CALLBACK: `${APP_ROOT}callback`,
    MICROSOFT_CALLBACK: `${APP_ROOT}microsoft_callback`,
    SET_PASSWORD: `${APP_ROOT}set-password`,
    CREATE_PASSWORD: `${APP_ROOT}create-password`,
    ACCEPT_INVITE: `${APP_ROOT}accept-invite`,
    FORGOT_PASSWORD: `${APP_ROOT}forgot-password`,
    RESET_PASSWORD: `${APP_ROOT}reset-password`,
    VERIFY_PASSWORD: `${APP_ROOT}verify-password`,
    MY_QUOTE: `${APP_ROOT}my-quote`,
    ADDRESS_DETAILS: `${APP_ROOT}my-quote/address-details`,
    ADD_NEW_QUOTE: `${APP_ROOT}my-quote/add-new-quote`,
    ADD_QUOTE: `${APP_ROOT}my-quote/add-quote`,
    CREATE_QUOTE: `${APP_ROOT}my-quote/create-quote`,
    QUOTE_DETAILS: `${APP_ROOT}my-quote/:id?`,
    BOOKING_STEPPER: `${APP_ROOT}my-quote/booking-stepper`,
    ORGANIZATION: `${APP_ROOT}organization`,
    DOCUMENTATION_HUB: `${APP_ROOT}documentation-hub`,
    ORDERS: `${APP_ROOT}orders`,
    ORDER_DETAILS_VIEW: `${APP_ROOT}orders/:id?`,
    BOOK_QUOTE: `${APP_ROOT}my-quote/book`,
    INTEGRATION: `${APP_ROOT}integrations`,
    SETTING: `${APP_ROOT}settings`,
    RADAR: `${APP_ROOT}radar`,
    RADAR_ORDER_DETAIL: `${APP_ROOT}radar-order-detail`,
    TRACK: `${APP_ROOT}track`,
    TRACK_ORDER_DETAIL: `${APP_ROOT}track/:id`,
    SETUP_ACCOUNT: `${APP_ROOT}setup-account`,
    ADDRESS_BOOK: `${APP_ROOT}address-book`,
    // Public, token-gated share-link pages — rendered OUTSIDE the AppLayout
    // (no top header, no left sidebar). Token comes via ?t= query string.
    SHARE_QUOTE_LINK: `${APP_ROOT}share-links/quote`,
    SHARE_ORDER_LINK: `${APP_ROOT}share-links/order`,
    SHARE_RADAR_ORDER_LINK: `${APP_ROOT}share-links/radar-order`,
    // Public WAL ID search. Served at / on track.westernalliancelogistics.com (see isPublicTrackingHost);
    // on the portal's own hostname it lives here, which is also how it is reached in local dev.
    PUBLIC_TRACKING: `${APP_ROOT}public-tracking`,
};

const DEFAULT_PUBLIC_TRACKING_HOST = 'track';

/**
 * True on the public tracking hostname: the one starting with window.PUBLIC_TRACKING_HOST ("track" in
 * production, "cp-dev-track" on dev; "track" when unset). That hostname serves the public WAL ID search
 * only: no login, no portal app, so nothing of the authenticated portal is reachable from it.
 */
export const isPublicTrackingHost = (hostname: string = window.location.hostname): boolean => {
    const configured = typeof window.PUBLIC_TRACKING_HOST === 'string' ? window.PUBLIC_TRACKING_HOST.trim().toLowerCase() : '';
    // An unset REACT_APP_PUBLIC_TRACKING_HOST leaves its %placeholder% in index.html.
    const host = configured && !configured.startsWith('%') ? configured : DEFAULT_PUBLIC_TRACKING_HOST;

    return hostname.toLowerCase().startsWith(`${host}.`);
};

/**
 * Query flag appended by the Share Tracking Link modal's Preview button.
 *
 * The share pages normally bounce a logged-in user to their authenticated detail page, which is
 * right for a recipient who happens to have an account — but it made Preview useless for the
 * internal user, who could never see their own link the way a recipient sees it. This flag opts
 * that one navigation out. It is added ONLY to the previewed URL; the link that gets copied and
 * sent to recipients stays clean.
 */
export const SHARE_LINK_PREVIEW_PARAM = 'preview';
